import React, { Fragment, useState, useEffect, useRef, useContext } from 'react'
import MetisMenu from "react-metismenu";
import { useLocation } from "react-router-dom";
import records from "../../Services/records";
import util from "../../Utils/util";
import { appContext } from '../../Utils/context';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faPen } from "@fortawesome/free-solid-svg-icons";
import { toast, Slide } from "react-toastify";
import { isEqual } from 'lodash';
import { SkeletonTheme } from "react-loading-skeleton";
import Skeleton from "react-loading-skeleton";
import {
  Row,
  Button,
  ButtonGroup,
} from "reactstrap";
import {
  MainNav,
  Marketing,
  StatusComponent,
  AddRecords,
  Tools,
  Account
} from "./NavItems";
import List from './List';
function VerticalNavFunction({ toggleMobileSidebar }) {
  const { groupOptions, setGroupOptions, myLists, setMyLists, user } = useContext(appContext)
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search);

  const [pipeline, setPipeline] = useState()
  const [menu, setMenu] = useState(MainNav)
  const [marketing, setMarketing] = useState(Marketing)
  const [addRecords, setAddRecords] = useState([])
  const [show, setShow] = useState(false)
  const [userTools, setUserTools] = useState([]);
  const [userAccount, setUserAccount] = useState([])
  const [listMenu, setListMenu] = useState([])
  const [myListDummy, setMyListDummy] = useState()
  const [loading, setLoading] = useState(true)


  const meow = useRef()
  const meow2 = useRef()


  useEffect(() => {
    if(user?.id){
    if (user?.cart_count !== undefined) {
      const updatedMainNav = MainNav.map(item => {
        if (item.label === "Cart") {
          return { ...item, label: `Cart (${user?.cart_count})` };
        }
        return item;
      });

      setMenu(updatedMainNav)
    }

    const newUserTools = [];
    const newUserAccount = []

    if (user?.is_staff || user?.is_customer_care) {
      newUserTools.push(Tools.find(tool => tool.label === "Customer Care"));}
      // newUserTools.push(Tools.find(tool => tool.label === "Partnership Portal"));
      if (user?.is_staff) {
      // newUserTools.push(Tools.find(tool => tool.label === "P-Portal"));
      newUserTools.push(Tools.find(tool => tool.label === "Admin Site"));
      newUserTools.push(Tools.find(tool => tool.label === "Payments Report"));
      newUserTools.push(Tools.find(tool => tool.label === "Coupon System"));
      newUserTools.push(Tools.find(tool => tool.label === "Scraper Dashboard"));
      newUserTools.push(Tools.find(tool => tool.label === "Virtual Portal"));

      newUserAccount.push(Account.find(acc => acc.label === "User Roles"));
    }
    if (user?.use_leads_api) {
      newUserTools.push(Tools.find(tool => tool.label === "P-Portal"));
      newUserTools.push(Tools.find(tool => tool.label === "Partnership Portal"));
    }
    if (user?.allow_affiliation) {
      newUserTools.push(Tools.find(tool => tool.label === "Affiliate Systems"));
    }
    if (user?.allow_record_page) {
      newUserAccount.push(Account.find(acc => acc.label === "Settings"));
    }
    setUserTools(newUserTools);
    setUserAccount(newUserAccount)
    setLoading(false)
  }
  }, [user])


  useEffect(() => {

    records.getStatusSettings().then((res) => {
      setGroupOptions(res?.data)
      // var q = StatusComponent[1]?.content?.sort((a, b) => {
      //   return (
      //     res?.data
      //       ?.map(function (e) {
      //         return e.id;
      //       })
      //       .indexOf(a.id) -
      //     res?.data
      //       ?.map(function (e) {
      //         return e.id;
      //       })
      //       .indexOf(b.id)
      //   );
      // });
      const q = res.data.map(({ options, ...rest }) => ({
        ...rest,
        to: `#/records/${rest.label.replace(/\s+/g, '-')}`
      }));

      const newPipe = StatusComponent.map((obj, k) => {
        if (obj?.label === 'Property') {
          return { ...obj, content: q }
        } 
        return obj
      })
      setPipeline(newPipe)

    }).catch((err) => {

    })

  }, [StatusComponent])


  useEffect(() => {
    // console.log("GroupOPt",groupOptions)
    if (groupOptions !== undefined) {
      records.getStatusSettings().then((res) => {
      // var q = StatusComponent[1]?.content?.sort((a, b) => {
      //   return (
      //     groupOptions
      //       .map(function (e) {
      //         return e.id;
      //       })
      //       .indexOf(a.id) -
      //     groupOptions
      //       .map(function (e) {
      //         return e.id;
      //       })
      //       .indexOf(b.id)
      //   );
      // });
      const q = res.data.map(({ options, ...rest }) => ({
        ...rest,
        to: `#/records/${rest.label.replace(/\s+/g, '-')}`
      }));
      const newPipe = StatusComponent.map((obj, k) => {
        if (obj?.label === 'Property') {
          return { ...obj, content: q }
        }
        return obj
      })
      setPipeline(newPipe)
    }).catch((err) => {

    })
    }

  }, [groupOptions])


  useEffect(() => {
    const updatedRecords = AddRecords.filter((obj) => {
      if (obj?.accessTo) {
        return obj.accessTo === util.getIsStaff();
      }

      return true;
    });

    //console.log("outside Record", updatedRecords)
    if(user?.lists){
      setAddRecords(updatedRecords);
    }
    else{
      const updatedData = updatedRecords.filter(item => item.label !== 'List Creation');
      setAddRecords(updatedData);
    }
    if (JSON.stringify(updatedRecords) !== JSON.stringify(addRecords)) {
     
      
      // console.log("Update Record", updatedRecords)
    }

    meow.current?.changeActiveLinkFromLocation()
    meow2.current?.changeActiveLinkFromLocation()

    const loc = `#${location?.pathname}`
    const id = searchParams.get('id');
    const node = document.querySelectorAll(".metismenu-link")


    for (let i = 0; i < node.length; i++) {
      let aa= loc
      if(id && loc === '#/records/'){
        aa = `${loc}?id=${id}`
      }
      if (node[i]?.hash === aa) {
        node[i].classList.add("active");
        node[i].style.backgroundColor = "#e0f3ff";
        node[i].style.color = "#1e90ff";
        node[i].style.fontWeight = "bold";
      }
      else {
        node[i].classList.remove("active");
        node[i].classList.remove("has-active-child");
        node[i].style.backgroundColor = "";
        node[i].style.color = "";
        node[i].style.fontWeight = "";

      }


    }

  }, [user,location, util?.getIsStaff()])


  useEffect(() => {
    const node = document.querySelectorAll(".metismenu-link")

    for (let i = 0; i < node.length; i++) {
      if (node[i]?.textContent === "AI Machine Learn Lists") {
        node[i].style.whiteSpace = "normal";
        node[i].style.lineHeight = "1.3rem";
        node[i].style.height = "2.9rem";
      }
    }
  }, [addRecords])


  useEffect(()=>{
    records.getListName().then((res)=>{
      setMyLists(res.data)
    }).catch((e)=>{
      console.log('error',e.data)
    })
  },[])


  useEffect(()=>{
    if (!isEqual(myListDummy, myLists)) {
      setMyListDummy(myLists);
    const categorizedLists = myLists.reduce((acc, list) => {
      // Check if list_type already exists in the accumulator
      const existingType = acc.find(item => item.label.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()) === list.list_type.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()));
      // const existingType = acc.find(item => item.label === list.list_type);
      if (existingType) {
        let name = list.list_name.replace(' ', '-').toLowerCase();
        // let name = list.list_name;
        let newObj = {
          label: name,
          to: `#/records/?id=${list?.id}`,
          // id:list?.id
        };
        // If list_type exists, push the current list to its content array
        existingType.content.push(newObj);
      } else {
        // If list_type doesn't exist, create a new category
        let name = list.list_name.replace(' ', '-').toLowerCase();
        // let name = list.list_name;
        let newObj = {
          label: name,
          to: `#/records/?id=${list?.id}`,
          // id:list?.id
        }
        acc.push({
          icon: 'pe-7s-folder', // You can set this icon as needed
          label: list.list_type.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()),
          // label: list.list_type,
          content: [newObj]
        });
      }
      return acc;
    }, []).map(category => ({
      ...category,
      label: `${category.label} (${category.content.length})`
    }));
    
    // let newObjects = [];
    // myLists.forEach((list, index) => {
    //   let name = list.list_name.replace(' ', '-').toLowerCase();
    //   let newObj = {
    //     id: list.id,
    //     icon: "pe-7s-folder",
    //     label: name,
    //     to: `#/records/${name}`
    //   };
    //   newObjects.push(newObj);
    // });
    setListMenu(categorizedLists)}
  },[myLists])

  const notify22 = (msg, type) =>
    toast(msg, {
      transition: Slide,
      autoClose: 5000,
      position: "top-right",
      type: type,

    });

  return (
    <Fragment>
{loading ? (
          <SkeletonTheme highlightColor="#E0E0E0">
                <Row className="mb-3">
                  <Skeleton
                    width={100}
                    height={28}
                    style={{ marginBottom: "1rem" }}
                  />
                  <Skeleton
                    height={24}
                    width={100}
                    style={{ marginBottom: "1rem", marginLeft: "1rem" }}
                  />
                  <Skeleton
                    height={24}
                    width={120}
                    style={{ marginBottom: "0.5rem", marginLeft: "1rem" }}
                  />
                  <Skeleton
                    width={100}
                    height={28}
                    style={{ marginBottom: "1rem" }}
                  />
                  <Skeleton
                    height={24}
                    width={100}
                    style={{ marginBottom: "1rem", marginLeft: "1rem" }}
                  />
                  <Skeleton
                    height={24}
                    width={120}
                    style={{ marginBottom: "0.5rem", marginLeft: "1rem" }}
                  />
                  <Skeleton
                    height={24}
                    width={100}
                    style={{ marginBottom: "1rem", marginLeft: "1rem" }}
                  />
                  <Skeleton
                    height={24}
                    width={120}
                    style={{ marginBottom: "0.5rem", marginLeft: "1rem" }}
                  />
                  <Skeleton
                    width={100}
                    height={28}
                    style={{ marginBottom: "1rem" }}
                  />
                  <Skeleton
                    height={24}
                    width={100}
                    style={{ marginBottom: "1rem", marginLeft: "1rem" }}
                  />
                  <Skeleton
                    height={24}
                    width={120}
                    style={{ marginBottom: "0.5rem", marginLeft: "1rem" }}
                  />
                  <Skeleton
                    width={100}
                    height={28}
                    style={{ marginBottom: "1rem" }}
                  />
                  <Skeleton
                    height={24}
                    width={100}
                    style={{ marginBottom: "1rem", marginLeft: "1rem" }}
                  />
                  <Skeleton
                    height={24}
                    width={120}
                    style={{ marginBottom: "0.5rem", marginLeft: "1rem" }}
                  />
                  <Skeleton
                    height={24}
                    width={100}
                    style={{ marginBottom: "1rem", marginLeft: "1rem" }}
                  />
                  <Skeleton
                    height={24}
                    width={120}
                    style={{ marginBottom: "0.5rem", marginLeft: "1rem" }}
                  />
                </Row>
          </SkeletonTheme>
        ):
        <>
         <h5 className="app-sidebar__heading">Menu</h5>
            <MetisMenu content={menu} onSelected={toggleMobileSidebar} ref={meow} activeLinkFromLocation
              className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down" />
      
            <h5 className="app-sidebar__heading">Add Records</h5>
            <MetisMenu content={addRecords} onSelected={toggleMobileSidebar} ref={meow} activeLinkFromLocation
              className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down" />
      
      
            {user.allow_record_page && (
              <>
                <h5 className="app-sidebar__heading">Pipeline</h5>
                <MetisMenu content={pipeline} onSelected={toggleMobileSidebar} ref={meow2} activeLinkFromLocation
                  className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down" />
              </>
            )}
            {user.allow_record_page && (
              <>
                <h5 className="app-sidebar__heading ">
                  <span className=''>My Lists</span>
                  <ButtonGroup size="sm" className='ms-5'>
                    <Button className="btn-pill" color="success" title="Add List" onClick={() => setShow(true)}>
                      <FontAwesomeIcon icon={faPlus} size="1x" />
                    </Button>
                    <Button className="btn-pill" color="secondary" title="Edit List" onClick={() => setShow(true)}>
                      <FontAwesomeIcon icon={faPen} size="1x" />
                    </Button>
                  </ButtonGroup>
                </h5>
                <MetisMenu closeOnOutsideClick={false} content={listMenu} onSelected={toggleMobileSidebar} activeLinkFromLocation
                  className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down" />
              </>
            )}
             {user.is_staff && (
              <>
                <h5 className="app-sidebar__heading">Marketing</h5>
                <MetisMenu content={marketing} onSelected={toggleMobileSidebar} activeLinkFromLocation
                  className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down" />
              </>
            )}
            
            {userTools.length > 0 && (
              <>
                <h5 className="app-sidebar__heading">Tools</h5>
                <MetisMenu content={userTools} onSelected={toggleMobileSidebar} ref={meow2} activeLinkFromLocation
                  className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down" />
              </>
            )}
      
            {userAccount.length > 0 && (
              <>
                <h5 className="app-sidebar__heading">Account</h5>
                <MetisMenu content={userAccount} onSelected={toggleMobileSidebar} ref={meow2} activeLinkFromLocation
                  className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down" />
              </>
            )}
      
            <List show={show} setShow={setShow} />
        </>}
    </Fragment>
  )
}

export default VerticalNavFunction